import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import cx from "classnames";
import { Button } from "semantic-ui-react";
import styles from "./styles.less";

const SlideMenu = ({ visible, unFixed, onToggle, children, isRtl }) => {
  const portlElement = document.body;
  const iconName = visible ? "close" : "cart";
  return ReactDOM.createPortal(
    <div
      className={cx(styles.menuWrapper, {
        [styles.visible]: visible,
        [styles.unFixed]: unFixed,
        [styles.rtl]: isRtl
      })}
    >
      <div className={styles.menu}>{children}</div>
      <div className={styles.menuBtnWrapper}>
        <Button
          className={styles.menuBtn}
          icon={iconName}
          onClick={onToggle}
          onKeyDown={onToggle}
        />
      </div>
    </div>,
    portlElement
  );
};

SlideMenu.propTypes = {
  isRtl: PropTypes.bool,
  visible: PropTypes.bool,
  unFixed: PropTypes.bool, // positioned absolute
  onToggle: PropTypes.func,
  children: PropTypes.node
};

export default SlideMenu;



// WEBPACK FOOTER //
// ./src/components/SlideMenu/SlideMenu.js